<div *ngIf="isVisible()" class="loading-overlay">
  <div class="spinner-border text-primary" role="status">
  </div>
</div>